import * as Yup from "yup";

export const getSchema = () => {

    return Yup.object({

        giroNegocio: Yup
            .mixed()
            .test(
                "giro-valido",
                "Debe seleccionar un giro de negocio válido",
                (value) =>
                    value &&
                    typeof value === "object" &&
                    value.gnCodigoCore
            )
            .required(
                "El giro de negocio es obligatorio"
            ),

        actividadEconomica: Yup
            .mixed()
            .test(
                "actividad-valida",
                "Debe seleccionar una actividad económica válida",
                (value) =>
                    value &&
                    typeof value === "object" &&
                    value.aeCodigoCore
            )
            .required(
                "La actividad económica es obligatoria"
            ),

        cuentaSeguro:
            Yup.boolean(),

        brokerActual: Yup
            .mixed()
            .nullable()
            .when(
                "cuentaSeguro",
                {
                    is: true,

                    then: (schema) =>
                        schema.required(
                            "El broker actual es obligatorio"
                        ),

                    otherwise: (schema) =>
                        schema.nullable()
                }
            ),

        aseguradoraActual: Yup
            .mixed()
            .nullable()
            .when(
                "cuentaSeguro",
                {
                    is: true,

                    then: (schema) =>
                        schema.required(
                            "La aseguradora actual es obligatoria"
                        ),

                    otherwise: (schema) =>
                        schema.nullable()
                }
            ),

        fechaVencimiento: Yup
            .string()
            .nullable()
            .when(
                "cuentaSeguro",
                {
                    is: true,

                    then: (schema) =>
                        schema.required(
                            "La fecha de vencimiento es obligatoria"
                        ),

                    otherwise: (schema) =>
                        schema.nullable()
                }
            )
    });
};